import { acompanhamentoPath, bookingLabel, conversaPath, individualBookingUrl, potencialPath, studentPortalUrl } from './siteDestinations'

function NavigationLinks() {
  return <>
    <a href={potencialPath}>O que dá para fazer</a>
    <a href={conversaPath}>A primeira conversa</a>
    <a href={acompanhamentoPath}>O acompanhamento</a>
    <a href="/#arthur">Sobre o Arthur</a>
    <a href={studentPortalUrl}>Portal do aluno</a>
  </>
}

export default function SiteHeader({ homeHref = '/' }: { homeHref?: string }) {
  return <header className="site-header">
    <a className="brand" href={homeHref} aria-label="Oficina IA: início"><img src="/assets/logo/symbol.svg" alt="" /><span>Oficina IA</span></a>
    <nav aria-label="Navegação principal"><NavigationLinks /><a className="nav-contact" href={individualBookingUrl} target="_blank" rel="noopener noreferrer">Marcar conversa <span aria-hidden="true">↗</span></a></nav>
    <details className="of-mobile-menu"><summary>Explorar <span aria-hidden="true">⌄</span></summary><nav aria-label="Explorar a Oficina"><NavigationLinks /><a className="of-mobile-menu__cta" href={individualBookingUrl} target="_blank" rel="noopener noreferrer">{bookingLabel} ↗</a></nav></details>
  </header>
}
